module.exports = __webpack_public_path__ + "img/norbotics-favicon-white.4b071f97.png";